module.exports = __webpack_public_path__ + "static/th-89e6b791273e650f6c05fe7d71e130b0.png";